import { useContext } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { AppMainStateContext } from "../../contexts/AppMainStateContext.tsx";

type buttonMode = "PREV" | "NEXT";

interface props {
  direction: buttonMode;
  scrollPositionX: number;
  scrollXWidth: number;
  scrollFunc: Function;
}

export default function ScrollGridButton({
  direction,
  scrollFunc,
  scrollPositionX,
  scrollXWidth,
}: props) {
  const { isMobile } = useContext(AppMainStateContext);
  return (
    <>
      {!isMobile && (
        <button
          className={`absolute z-20 top-1/2
        ${direction === "PREV" ? "left-0" : "right-0"}
        ${direction === "PREV" && scrollPositionX <= 0 && "hidden"}
        ${direction === "NEXT" &&
            Math.ceil(scrollPositionX) >= scrollXWidth && "hidden"}
        bg-neutral-500 -translate-y-1/2 py-6 rounded transition duration-200 hover:cursor-pointer hover:bg-[#007CC1]`}
          onClick={() => scrollFunc(direction)}
        >
          {isMobile}
          {direction === "PREV" && <ChevronLeftIcon className={"w-8 h-8 "} />}
          {direction === "NEXT" && <ChevronRightIcon className={"w-8 h-8"} />}
        </button>
      )}
    </>
  );
}
